module.exports = __webpack_public_path__ + "img/download-app-store.d5b7c3e6.webp";